import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QueuePlayNextIcon(props: IconProps) {
    return <Icon {...props} iconKey={"queue_play_next"}/>
}
